module.exports = __webpack_public_path__ + "img/深圳市达通源科技有限公司LOG.c0f04b24.jpg";